import { render, staticRenderFns } from "./batteryCarUnitReport.vue?vue&type=template&id=3c54a746&scoped=true"
import script from "./batteryCarUnitReport.vue?vue&type=script&lang=js"
export * from "./batteryCarUnitReport.vue?vue&type=script&lang=js"
import style0 from "./batteryCarUnitReport.vue?vue&type=style&index=0&id=3c54a746&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c54a746",
  null
  
)

export default component.exports